import { LS2KIDS_CONSTANTS } from "../constants";

/**
 * A grid icon.
 * tlc.ls2kids.model.GridIcon
 */
export class KidsGridIcon {
	constructor(category, layout) {
		this.category = category;
		this.layout = layout;
	}
	/**
	 * Render the icon
	 */
	render() {
		this.element = $('<li></li>')
			.addClass('icon')
			.data('index', this.index);

		var link = $('<a></a>')
			.attr('title', this.category.name)
			// TODO: externalize URL
			.attr('href', '/kids#' + LS2KIDS_CONSTANTS.Urls.categorySearch + '?id=' + this.category.id);

		this.element.append(link);

		var background = $('<div></div>')
			.addClass('glass-like-background');

		link.append(background);

		//	var div = $("<div></div>")
		//		.addClass('icon-image')
		//		.css({
		//			"background-image": "url(" + LS2KIDS_CONSTANTS.restUrls.category.onImage( this.id ) + ")",
		//			"background-repeat": "no-repeat"
		//		});
		//
		//	background.append( div );
		var icon = $('<img />')
			.attr('alt', this.category.name)
			.attr('src', LS2KIDS_CONSTANTS.restUrls.category.onImage(this.category.id))
			.attr('height', '100%')
			.attr('width', '100%');

		background.append(icon);
	}
	/**
	 * Resize the icon
	 * @param {number} width
	 * @param {number} height
	 */
	resize(width, height) {
		this.element.css({
			'width': width,
			'height': height
		});

		this.resetPosition();
	}
	/**
	 * Hide the icon
	 */
	hide() {
		this.element.hide();
	}
	/**
	 * Show the icon
	 */
	show() {
		this.element.show();
	}
	/**
	 * move the icon back to where it should be
	 */
	resetPosition() {
		this.element.css({
			position: 'absolute',
			left: this.left,
			top: this.top
		});
	}
	move(left, top) {
		this.element.css({
			position: 'fixed',
			left: left,
			top: top
		});
	}
}

/**
 * @type {number}
 */
KidsGridIcon.prototype.id = 0;

/**
 * @type {string}
 */
KidsGridIcon.prototype.name = '';

/**
 * @type {jQuery|null}
 */
KidsGridIcon.prototype.element = null;

/**
 * @type {number}
 */
KidsGridIcon.prototype.index = 0;

/**
 * @type {number}
 */
KidsGridIcon.prototype.row = 0;

/**
 * @type {number}
 */
KidsGridIcon.prototype.col = 0;

/**
 * @type {number}
 */
KidsGridIcon.prototype.left = 0;

/**
 * @type {number}
 */
KidsGridIcon.prototype.top = 0;

/**
 * @type {number}
 */
KidsGridIcon.prototype.page = 0;







